











 
















const node = {
  "kind": "InlineDataFragment",
  "name": "useGotoPrev_meeting"
};

(node ).hash = "d08b493d0ec3a5c4d6a7ca793e1d417b";

export default node;
